import styled from "styled-components";

export const Content = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.colors.secondary10};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 400;
  border-radius: 8px;
  color: ${({theme}) => theme.colors.secondary100};
  .toconnect {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        flex-wrap: wrap;
        .instructions {
          display: flex;
          flex-direction: column;
        }
        .qr {
          width: 200px;
          height: 200px;
          background-color: ${({theme}) => theme.colors.secondary40};
          display: flex;
            justify-content: center;
            align-items: center;
          .reloading{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 40px;
            height: 40px;
            background-color: ${({theme}) => theme.colors.secondary10};
            border-radius: 8px;
            cursor: pointer;
            box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
            svg{
              color: ${({theme}) => theme.colors.primary};
              height: 25px;
              width: 25px;
            }
          }
        }
      }
`;
